import { Tooltip } from 'element-ui'
import './style.scss'

const YTooltip = Tooltip
YTooltip.$depends = [Tooltip]
YTooltip.$name = 'y-tooltip'
YTooltip._name = 'Tooltip 文字提示'

export default YTooltip
